
let url = process.env.VUE_APP_API_HOST;
// url = 'https://api.test.gdteacher.com'
let uploadUrl = process.env.VUE_APP_UPLOAD_HOST;
let bucketName = process.env.VUE_APP_UPLOAD_BUCKET_NAME;

export const apis = {
    api: {
        preview: 'http://eezxyl.ttcn.cn/?furl=', //预览地址
        system:{
            getAPPInfo: url + '/baseData/app-info/search', //获取应用信息
            checkToken: url + '/oauthService/checkToken/'
        },
        upload: {
            bucketName:bucketName,//bucketName
            // http://shxy.file.gdteacher.com+`/upload?bucketName=${bucketName}&filecwd=class/make/file/`
            apiUpload: uploadUrl+`/upload?bucketName=${bucketName}&filecwd=class/make/file/`,   //阿里云上传
            aliyuncs: `http://${bucketName}.oss-cn-shenzhen.aliyuncs.com`,   //阿里云上传，文件真实路径域名地址
            getUploadSign: url +  '/studyService/video/video-videoinfo/getUploadSign'   //获取阿里云上传参数
        },
        coursedetail: {
            batchInsertActivityInfo: url + '/studyService/activity-info/batchInsertActivityInfo',   //添加章
            insertOrUpdateActivityInfo: url + '/studyService/activity-info/insertOrUpdateActivityInfo',   //编辑章
            deleteActivityInfoById: url + '/studyService/activity-info/deleteActivityInfoById',  //删除章
            batchInsertActivityTask: url+'/studyService/activityTask/activity-task/batchInsertActivityTask',  //添加节
            updateTaskInfo: url+'/studyService/activityTask/activity-task/updateTaskInfo',  //编辑节
            saveOrUpdateTopic: url+'/studyService/groupResult/research-topic/saveOrUpdateTopic',    //添加话题讨论
            saveOrUpdateReadLearning: url+'/studyService/articleRead/read-learning/saveOrUpdateReadLearning',   //添加阅读
            saveOrUpdateVote: url+'/studyService/vote/vote-voteinfo/saveOrUpdateVote',   //问卷调查
            excelImport: url+'/studyService/vote/vote-voteinfo/excel-import',   //上传问卷文件
            downloadTemplate: url+'/studyService/vote/vote-voteinfo/downloadTemplate',   //下载问卷文件
            returnVoteSubjectList: url+'/studyService/vote/vote-voteinfo/returnVoteSubjectList',   //预览问卷文件
            getActById: url+'/studyService/tache/task-act/getActById',  //查询活动详情
            deleteActById: url+'/studyService/tache/task-act/deleteActById',   //删除活动
            updateActivitySort: url+'/studyService/activity-info/updateActivitySort',  //更新章排序
            updateTaskSort: url+'/studyService/activityTask/activity-task/updateTaskSort',  //更新节排序
            updateActSort: url+'/studyService/tache/task-act/updateActSort',   //更新活动排序
            taskDelete: url+'/studyService/activityTask/activity-task/delete',   //删除节
            getResearchMessageById: url+'/studyService/plan/research-project/getResearchMessageById',    //获取课程信息 章节活动
            resource: url+'/ecloudResource/resource/page-search',   //获取资源库
            getResource: url+'/ecloudResource/resource/course_keyword/getResourceListByKeyword',   //新获取资源库
            execVideoResource: url+'/studyService/video/video-videoinfo/execVideoResource',   //视频转码
            checkJobDone: url+'/studyService/video/video-videoinfo/checkJobDone',   //转码进度
            searchQastoreList: url+'/studyService/qastore/qastore-qastoreinfo/searchQastoreList',   //题目列表
            saveOrUpdateVideoActAndQa: url+'/studyService/video/video-videoinfo/saveOrUpdateVideoActAndQa',   //保存弹题
            resourcedetail: url+'/ecloudResource/resource/detail',    //获取资源详情
            getMediaIdByOssUrl: url+'/studyService/video/video-videoinfo/getMediaIdByOssUrl',    //根据oss地址获取媒体id
            getPlayerParamByMediaId: url+'/studyService/video/video-videoinfo/getPlayerParamByMediaId',    //根据媒体id获取阿里播放参数
            getMediaWorkflowExecutionByRunId: url+'/studyService/video/video-videoinfo/getMediaWorkflowExecutionByRunId',    //获取转码进度
            
            
        },
        courseQuestionBank: {
            getQuestionList: url + '/studyService/qastore/qastore-qastoreinfo/searchQastoreList',//获取题库列表
            postQastore: url + '/studyService/qastore/qastore-qastoreinfo/saveOrUpdateQastore',//新增题目
            getQuestionDetail: url + '/studyService/qastore/qastore-qastoreinfo/getQastoreAndOption/', //获取题目详情
            deleteQastore: url + '/studyService/qastore/qastore-qastoreinfo/delete',//批量删除题目
            qastoreExport: url + '/studyService/qastore/qastore-qastoreinfo/excel-export', //到处题目
            importExcel: url + '/studyService/qastore/qastore-qastoreinfo/excel-import',//批量导入题目
            lookRecord: url + '/studyService',
            templateUrl: url + '/studyService/qastore/qastore-qastoreinfo/downloadTemplate' //模板下载地址
        },
        courseInfoSetting: {
            getResearchMessageById: url + '/studyService/plan/research-project/getResearchMessageById?researchId=',//获取课程信息
            postAutoBuildLesson: url + '/studyService/activity-info/autoSaveActivityTaskAndAct',//自动建课
            getCourseInfo: url + '/studyService/introduce/research-introduce/',//id获取单独课程信息(修改也是这个)
            getIntroduceList: url + '/studyService/introduce/research-introduce/queryIntroduceList?researchId=',//课程信息介绍列表
            getProficientList: url + '/studyService/classExpert/queryExpertList',//获取专家列表
            postProficient: url + '/studyService/classExpert/saveOrUpdateExpert',//添加(编辑)专家
            getProficient: url + '/studyService/classExpert/queryExpert',//获取专家详情
            deleteProficient: url + '/studyService/classExpert/',
            getCourseTitleInfo: url + '/ecloudResource/resource/title/getCourseTitleInfo/', //根据课程id获取片头信息
            getCourseTitleList: url + '/ecloudResource/resource/title/page-search/', //根据课程片头列表
            saveCourseTitle: url + '/studyService/title/research-title/saveCourseTitle', //制作平台课程更换片头
            updateVideoExpertNameBatch: url+'/studyService/tache/task-act/updateVideoExpertNameBatch',    //获取资源详情
            
        },
        user: {
            login: url + '/oauthService/oauth/token',
            imageUrl: url + '/captcha/imageUrl',
            checkGroupLeader: url + '/trainService/workshop/checkGroupLeader',   //检验身份
            getTestAddrLists: url + '/studyService/plan/research-project/getTestAddrLists',   //预览课程获取特殊角色userid（4个可用userid换jti）
        },
        coursework: {
            getAllAttInfo: url + '/studyService/work/att-attinfo/getAllAttInfo?researchId=', //获取作业
            addCoursework: url + '/studyService/work/att-attinfo', //新增作业
            putCoursework: url + '/studyService/work/att-attinfo/', //修改作业
            delCoursework: url + '/studyService/work/att-attinfo/deleteAttInfoById/', //删除指定id的课程作业信息
            getOneAttInfoById: url + '/studyService/work/att-attinfo/getOneAttInfoById?attinfoId=', //通过当前课程作业id获取课程作业信息及题目信息
            saveOrUpdateAssignment: url + '/studyService/work/att-attassignment/saveOrUpdateAssignment', //新建附件题目
            moveAssignment: url + '/studyService/work/att-attassignment/moveAssignment', //移动题目顺序
            delAssignment: url + '/studyService/work/att-attassignment/removeAssignment/', //删除附件题目
            downloadTemplate: url+'/studyService/work-question/downloadTemplate',    //下载模板
            excelimport: url+'/studyService/work-question/excel-import/',    //上传模板
            saveOrUpdateWorkQuestion: url+'/studyService/work-question/saveOrUpdateWorkQuestion',    //提交测试题目
            
            
        },
        courseDataUpload: {
            getAllAttachmentByResearchId: url + '/studyService/groupResult/research-attachment/getAllAttachmentByResearchId?researchId=', //获取当前课程的所有资料
            saveOrUpdateAttachment: url + '/studyService/groupResult/research-attachment/saveOrUpdateAttachment', //编辑课程附件
            delAttachment: url + '/studyService/groupResult/research-attachment/', //删除课程附件
            getResourceLibrary: url + '/ecloudResource/resource/page-search', //获取资源库
        }
    }
}

